<template>
    <div id="app">
        <top-menu></top-menu>
        <div class="pt-2 pt-lg-0">
            <router-view></router-view>
        </div>
        <bottom-footer></bottom-footer>
    </div>
</template>

<script>
import TopMenu from './components/TopMenu.vue';
import BottomFooter from './components/Footer.vue';

export default {
  name: 'app',
  components: {
    BottomFooter,
    TopMenu,
  },
};
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
        padding-top: 85px;
    }

    @media (min-width: 992px) {
        #app {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: left;
            color: #2c3e50;
            padding-top: 117px;
        }
    }
</style>
